import React from 'react';
import TFForm from './typeform-card'
import CallToAction from './call-to-action';
import 'bootstrap/dist/css/bootstrap.css?rnd=61';
import InstructionsMobile from './instruction-mobile';



const typeform_attributes = 'div data-tf-widget="ML3rFcAo" data-tf-opacity="1" data-tf-hide-headers data-tf-iframe-props="title=Meg & Hugo Lander" data-tf-medium="snippet" style="width:100%;height:400px;"';
const typeform_script_src = 'src="//embed.typeform.com/next/embed.js"'

function Form_Container() {
    return (
        <div className="container-fluid has-bg-img py-0" id="form_container">
            <div className='row pb-5 mb-5' id='form_container_main_row'>
                
                <div className='my-3 py-3 d-flex align-items-center col-lg-5 offset-lg-1 col-md-5 offset-md-1 col-sm-8 offset-sm-2 rounded order-lg-1 mx-auto order-md-2 order-sm-2 px-3 pb-3'>
                <div className='mt-0 pb-3 row d-flex flex-column rounded pb-3' id='card-column'>
                    <div className='col'>
                    <CallToAction />
                    </div>
                    </div>
                </div>
                <div className='mt-0 pt-0 d-flex align-items-center col-lg-4 offset-lg-1 col-md-12 col-sm-12 order-lg-2 mx-auto order-md-1 order-sm-1 pb-3 mb-3'>
                    <TFForm />
                </div>
            </div>
            {/* <div className='row pt-4 mt-2 mb-3'>
            <div className='col-12 mx-auto'>
                    {/* <InstructionsMobile /> */}
                    </div>
                    // </div> */}
        
            
    );
}

export default Form_Container

